<template>
  <div>
    <van-radio-group :value="issue.select" icon-size="18px">
      <ul class="image-choice-wrap  clearfix">
        <li v-for="item in issue.items" :key="item.id">
          <image-choice-item :item="item" @click="onChangeValue(item)" :class="{ 'choice-checked': item.id === issue.select }">
            <template v-slot:icon>
              <van-radio :name="item.id">
                <template v-slot:icon="{ checked }">
                  <icon-radio :value="checked" />
                </template>
              </van-radio>
            </template>
            <template v-slot:vote>
              <vote-progress
                  v-if="showVoteProgress && issue.select"
                  :vote="question.vote"
                  :label="item.id"
                  :checked="issue.select === item.id"
                  :selected="!!issue.select"
              />
            </template>
          </image-choice-item>
        </li>
      </ul>
    </van-radio-group>
  </div>
</template>

<script>
import ImageChoiceItem from '@/questions/components/ImageChoiceItem'
import IconRadio from '@/components/base/IconRadio'
import VoteProgress from '../components/VoteProgress.vue'

export default {
  name: 'ImageChoice',
  components: { VoteProgress, IconRadio, ImageChoiceItem },
  changeExpr: 'issue.select',
  methods: {
    onChangeValue(item) {
      if (item.id === this.issue.select) {
        if (!this.question.required) {
          this.issue.select = ''
        }
      } else {
        this.issue.select = item.id
      }
    }
  }
}
</script>
